// Use the appropriate API base URL based on the environment
export const restrictedServerDomainNameResolver = () => {
    let url = '';
    switch (process.env.REACT_APP_API_CKMS_ENVIRONMENT_NAME) {
      case 'dev':
        url =  "https://apim-na.dev.mypepsico.com/cgf/ckms-api/v1/"
        break;
      case 'staging':
        url = 'https://staging-api.example.com';
        break;
      case 'production':
        url = 'https://api.example.com';
        break;
      default:
        url = "https://apim-na.dev.mypepsico.com/cgf/ckms-api-preprod-snt/v1/";
        break;
    }
    return url;
  };
  
  // Endpoint paths (without base URLs)
  export const RESTRICTEDSERVERENDPOINTS = {
    restrictedUpload: '/api/upload',
  };
  